const __vite_glob_0_40 = "<svg xmlns=\"http://www.w3.org/2000/svg\" data-name=\"Website Icons\" viewBox=\"0 0 100 100\"><path d=\"M14.85 33.04c.5-.54 1.19-.96 1.88-.96.62 0 1.24.22 1.74.68l31.54 28.98 31.54-28.98a2.56 2.56 0 0 1 3.62.14c.96 1.04.9 2.65-.14 3.61L51.75 67.23c-.98.91-2.49.91-3.48 0L14.98 36.52c-1.02-.82-1.09-2.44-.13-3.48Z\"/></svg>";

export { __vite_glob_0_40 as default };
